<template>
    <div id="app">
        <!-- 语言切换已移至 Index 页面按钮网格中 -->
        <!-- <div class="language-switcher">
            <language-switch></language-switch>
        </div> -->
        
        <!-- 添加测试组件切换按钮 
        <div class="test-toggle">
            <el-button 
                size="small" 
                @click="toggleI18nTest" 
                :type="showI18nTest ? 'danger' : 'success'"
            >
                {{ showI18nTest ? '隐藏测试组件' : '显示测试组件' }}
            </el-button>
        </div>
        -->
        <!-- i18n测试组件 
        <i18n-test v-if="showI18nTest"></i18n-test>-->
        
        <keep-alive>
            <router-view v-if="this.$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!this.$route.meta.keepAlive"></router-view>
    </div>
</template>

<script>
import LanguageSwitch from '@/components/LanguageSwitch.vue'
import I18nTest from '@/components/I18nTest.vue'

export default {
    components: {
        LanguageSwitch,
        I18nTest
    },
    data() {
        return {
            showI18nTest: true // 设置为true以显示测试组件，修改为false以禁用
        }
    },
    methods: {
        toggleI18nTest() {
            this.showI18nTest = !this.showI18nTest;
        }
    }
};
</script>

<style lang="scss">
html, body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
}

#app {
    font-family: 'Microsoft YaHei', Helvetica, Arial, sans-serif,"宋体";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /*text-align: center;*/
    color: #2c3e50;
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
}
/*全局表格样式*/
.el-table{
    th{
        height: 26px;
        line-height: 26px;
        padding: 6px 0px;
        background: #f4f8fb;
        color: #505050;
        font-weight: bold;
        border-color: #e9ebef;
    }
    td{
        height: 20px;
        line-height: 20px;
        padding: 6px 0px;
        border-color: #e9ebef;
    }
}
.language-switcher {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 1000;
}
.test-toggle {
    position: fixed;
    top: 60px;
    right: 20px;
    z-index: 1000;
}
</style>



// WEBPACK FOOTER //
// src/App.vue